module.exports = __webpack_public_path__ + "static/media/tutorial-start-pin.c626da83.svg";